// Central source of truth for business info. Update these values here
// and they propagate across every page, the footer, and SEO metadata.

export const SITE = {
  name: 'Biryanify',
  tagline: 'Dum-cooked biryani, tiffins & mandi',
  cuisine: 'Hyderabadi · South Indian · Arabian Mandi',
  city: 'Irving, TX',

  about: [
    'At Biryanify, biryani isn’t fast food. Basmati is layered with marinated meat and whole spices, sealed under a tight lid, and finished slowly over dum until every grain carries the aroma of saffron, mint and fried onion.',
    'Around it sits a whole world of South Indian comfort — tawa-crisp dosas and idli in the morning, chilli-fired 65s and kebabs to start, Arabian al faham mandi to share, and cooling falooda and kulfi to finish.',
    'It’s the food of Hyderabad and the south, cooked with patience and served fresh every day in the heart of Irving, Texas.',
  ],

  phone: '(214) 377-8283',
  phoneHref: 'tel:+12143778283',
  email: 'hello@biryanify.com',
  emailHref: 'mailto:hello@biryanify.com',

  address: {
    line1: '9400 N MacArthur Blvd',
    line2: 'Irving, TX 75063',
    full: '9400 N MacArthur Blvd, Irving, TX 75063',
    mapsUrl: 'https://www.google.com/maps/search/?api=1&query=Biryanify+9400+N+MacArthur+Blvd+Irving+TX+75063',
  },

  // PLACEHOLDER hours — confirm & adjust here.
  hours: [
    { day: 'Monday', time: '11:00 AM – 10:00 PM' },
    { day: 'Tuesday', time: '11:00 AM – 10:00 PM' },
    { day: 'Wednesday', time: '11:00 AM – 10:00 PM' },
    { day: 'Thursday', time: '11:00 AM – 10:00 PM' },
    { day: 'Friday', time: '11:00 AM – 11:00 PM' },
    { day: 'Saturday', time: '11:00 AM – 11:00 PM' },
    { day: 'Sunday', time: '11:00 AM – 10:00 PM' },
  ],

  // Native online ordering (cart + checkout) is built in, so third-party
  // links are optional. Add them here to show quick-order buttons.
  order: {},
  social: {},
} as const;

// The word marquee shown between sections.
export const MARQUEE = [
  'Hyderabadi Dum Biryani',
  'Al Faham Mandi',
  'Crispy Dosas',
  'Chicken 65',
  'Haleem',
  'Shawarma',
  'Kebabs & Grills',
  'Falooda & Kulfi',
];
